import { ModalContent, ModalFooter } from '@components/modal';

const ArchiveModal = ({ archived, onArchive }) => {
  return (
    <ModalContent title={`Confirm ${archived ? 'Unarchive' : 'Archive'}`}>
      <section className='modal-body'>
        <div>
          <p>Are you sure you want to {archived ? 'unarchive' : 'archive'} the selected request(s)?</p>
        </div>
      </section>
      <ModalFooter onSave={onArchive} saveText='Yes' cancelText='No' onCancel={() => {}} />
    </ModalContent>
  );
};

export default ArchiveModal;
